import React from 'react';
import Sidebar from '@/components/Sidebar';
import { Calendar, Sparkle } from '@phosphor-icons/react';

const AuditPlansPage = () => {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      
      <div className="ml-64 flex-1">
        <div className="p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-heading font-medium text-text-primary mb-2">
              Audit Plans
            </h1>
            <p className="text-text-secondary">
              Customised audit plans aligned to your regulatory risks
            </p>
          </div>

          <div className="text-center py-20">
            <Calendar size={64} className="mx-auto mb-4 text-gold" weight="light" />
            <h2 className="text-2xl font-heading font-medium text-text-primary mb-2">
              Coming Soon
            </h2>
            <p className="text-text-secondary">
              Audit planning module is under development
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditPlansPage;
